import { Controller } from "@hotwired/stimulus"

// Configuration factory for slider settings
const createSliderConfig = (maxValue, includePips = false) => {
  const baseConfig = {
    range: {
      'min': 0,
      'max': 1
    },
    start: 0.1,
    step: 0.1,
    connect: [true, false],
    orientation: 'vertical',
    direction: 'rtl',
  };

  if (!includePips) return baseConfig;

  return {
    ...baseConfig,
    pips: {
      mode: 'steps',
      values: [0, maxValue],
      density: 10,
      format: {
        to: function (value) {
            return value * 100;
        },
        from: function (value) {
            return Number(value) / 100.0;
        }
    }
    }
  };
};

export default class extends Controller {
  static targets = ['sliderEffective', 'sliderStandard', 'input'];

  async connect() {
    try {
      // Dynamically import noUiSlider
      const { default: noUiSlider } = await import(
        'nouislider'
      );

      this.values = JSON.parse(this.element.dataset.values);
      const maxValue = parseFloat(this.values.slice(-1)[0]);

      // Initialize sliders
      this.sliderEffective = noUiSlider.create(
        this.sliderEffectiveTarget,
        createSliderConfig(maxValue)
      );

      this.sliderStandard = noUiSlider.create(
        this.sliderStandardTarget,
        createSliderConfig(maxValue, true)
      );

      // Set initial values and bind events
      this.initializeSliders();
    } catch (error) {
      console.error('Failed to initialize sliders:', error);
    }
  }

  initializeSliders() {
    // Set initial value
    this.sliderEffective.set(this.inputTarget.value);

    // Bind events
    this.sliderStandard.on('change', () => this.change());
    this.sliderEffective.on('change', () => this.change());
    this.sliderEffective.on('update', () => this.sliderStandardUpdate());
    this.sliderStandard.on('update', () => this.sliderEffectiveUpdate());
  }

  sliderStandardUpdate() {
    const value = 1 - this.sliderEffective.get();
    const formattedValue = value.toFixed(2);

    if (this.sliderStandard.get() !== formattedValue) {
      this.sliderStandard.set(value);
      this.changeValue();
    }
  }

  sliderEffectiveUpdate() {
    const value = 1 - this.sliderStandard.get();
    const formattedValue = value.toFixed(2);

    if (this.sliderEffective.get() !== formattedValue) {
      this.sliderEffective.set(value);
      this.changeValue();
    }
  }

  changeValue() {
    if (this.sliderEffective.get() < 0.1) return;

    this.inputTarget.value = this.sliderEffective.get();
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }

  change() {
    if (this.sliderEffective.get() < 0.1) {
      this.sliderEffective.set(0.1);
    }
  }

  disconnect() {
    // Clean up sliders
    ['sliderEffective', 'sliderStandard'].forEach(slider => {
      if (this[slider]) {
        this[slider].destroy();
        this[slider] = null;
      }
    });
  }
}
